import { action } from 'satcheljs';

export const getDomainState = action('getDomainState');
